"use client";
import { useRef, useState, useEffect } from "react";

import { Container, Row, Col } from 'react-bootstrap';


import AboutMe from '../components/about'
import Preloader from "../components/preload";
import Footer from "../components/footer";
import ExperienceTabs from "../components/experience";
import Projects from "../components/projects";
import Contact from "../components/contact";
import ITemMenu from "../components/menubar";

const MainP = () => {

    const [loading, setLoading] = useState(true);

    const handleImageLoad = () => {
        setLoading(false);
    };

    return (
        <Container className="relative isolate">
            {loading && <Preloader onFinish={handleImageLoad} />}
            {!loading && (
                <Col>
                    <ITemMenu/>
                    <AboutMe />
                    <ExperienceTabs/>
                    <Projects/>
                    <Contact/>
                    <Footer />
                </Col>
            )}
        </Container>
    )
}

export default MainP